import React from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import { Refresh } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const ESIMOrdersHeader = ({ onRefresh, loading }) => {
  const { t } = useTranslation();

  return (
    <Box display="flex" justifyContent="space-between" mb={2}>
      <Typography variant="h4" gutterBottom>
        {t("esim.orders.yourESIMs")}
      </Typography>
      <Button
        variant="outlined"
        onClick={onRefresh}
        disabled={loading}
        startIcon={loading ? <CircularProgress size={20} /> : <Refresh />}
      >
        {t("common.actions.refresh")}
      </Button>
    </Box>
  );
};

export default ESIMOrdersHeader;
